import { useMemo } from 'react'
import { useDiscountContext } from '@context/discountContext'

const discountBannerCondition = ['/search', '/puppy']

export const useDiscountBanner = (
  isDiscountBannerClosed: boolean,
  currentPath: string
) => {
  const { discount, endDate, now } = useDiscountContext()

  const hasBanner = useMemo(
    () =>
      discountBannerCondition.some(
        (cond) => currentPath.includes(cond) || currentPath === '/'
      ) &&
      !(now > endDate) &&
      !isDiscountBannerClosed &&
      !!discount?.amount &&
      discount?.bannerText !== '<p><br></p>' &&
      discount?.bannerText !== null &&
      !discount?.customerSpecific,
    [currentPath, isDiscountBannerClosed, discount, now, endDate]
  )

  return { hasBanner, discount }
}
